module.exports = __webpack_public_path__ + "img/leftFlower@2x.06058a89.png";